<div class="wrapper flex-{{ direction }}">
  <ng-content select="[heading]"></ng-content>
  <div class="information" *ngIf="label">
    <cf-text touchSize="sm" weight="500">{{ label }}</cf-text>
  </div>
  <div class="information" [class.align-items-start]="oldDay" *ngIf="day">
    <svg cfIcon="calendar_blank"></svg>
    <div class="d-flex flex-column">
      <cf-text size="sm" touchSize="sm" weight="500">{{ day | dateFormat }}</cf-text>
      <cf-text textDecoration="line-through" color="grey-60" touchSize="sm" *ngIf="oldDay">
        {{ oldDay | dateFormat }}
      </cf-text>
    </div>
  </div>
  <div class="information" [class.align-items-start]="oldTime" *ngIf="time">
    <svg cfIcon="clock"></svg>
    <div class="d-flex flex-column">
      <cf-text size="sm" touchSize="sm" weight="500">
        {{ time }} - {{ timeTo() }} ({{ duration }} {{ "duration_mins" | translate }})
      </cf-text>
      <cf-text textDecoration="line-through" color="grey-60" touchSize="sm" *ngIf="oldTime">
        {{ oldTime }} - {{ timeTo(oldTime, oldDuration) }} ({{ oldDuration }} {{ "duration_mins" | translate }})
      </cf-text>
    </div>
  </div>

  <div class="information" *ngIf="timezone">
    <svg cfIcon="timezone"></svg>
    <cf-text size="sm" touchSize="sm" weight="500">
      {{
        "booking.timezone"
          | translate
            : {
                timezone: (timezone | timezoneName).toString(),
                time: (timezone | currentTime: timeFormat).toString(),
              }
      }}
    </cf-text>
  </div>

  <ng-container *ngIf="location">
    <ng-container *ngIf="location.option !== 'OFFLINE'">
      <div class="information" *ngIf="location.meeting_tool !== EMeetingTool.Other; else otherTmp">
        @if (location.option === "NOT_SPECIFIED") {
          <svg cfIcon="video"></svg>
          <cf-text size="sm" touchSize="sm" weight="500">
            {{ "dashboards.no_meeting_location_specified" | translate }}
          </cf-text>
        } @else {
          <svg cfIcon="video"></svg>
          <cf-text size="sm" touchSize="sm" weight="500">
            {{ meetingToolName }}
          </cf-text>
        }
      </div>
      <ng-template #otherTmp>
        <div class="information" *ngIf="location.other_meeting as meetingUrl; else otherWithoutUrlTmp">
          <svg cfIcon="share" class="stroked tw:text-blue-50"></svg>
          <a cf-link maxLineClamp="1" touchSize="sm" [href]="meetingUrl" target="_blank" rel="noreferrer noopener">
            {{ meetingUrl }}
          </a>
        </div>
      </ng-template>

      <ng-template #otherWithoutUrlTmp>
        <div class="information">
          <svg cfIcon="location"></svg>
          <cf-text size="sm" touchSize="sm" weight="500">{{ "not_specified" | translate }}</cf-text>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="location.option !== 'MEETING_TOOL' && location.option !== 'NOT_SPECIFIED'">
      <div class="information" *ngIf="location.location_address">
        <svg cfIcon="location"></svg>
        <cf-text size="sm" touchSize="sm" weight="500" className="text-cut max-1">
          {{ location.location_address }}
        </cf-text>
      </div>
    </ng-container>
  </ng-container>

  <div class="information" *ngIf="participantsTmp">
    <svg cfIcon="group_people" class="align-self-baseline"></svg>
    <ng-container *ngTemplateOutlet="participantsTmp"></ng-container>
  </div>
</div>
